import React from 'react';
import TextExtended from '../components/text-extended/text-extended';
import { useTranslate } from '../context/api-context/translations/use-translate';
import styles from './list-loading-state.module.scss';
import { Spinner } from '../../ui';
import { LIST_LOADING } from '../../common/constants/data-hooks';
import { useConfiguration } from '../context/configuration-context/use-configuration';
const ListLoadingState = () => {
    const t = useTranslate();
    const { screenshotMode } = useConfiguration();
    return (React.createElement("div", { "data-hook": LIST_LOADING, className: styles.container },
        React.createElement("div", { className: styles.spinner },
            React.createElement(Spinner, { diameter: 17, isStatic: screenshotMode })),
        React.createElement("div", { className: styles.text },
            React.createElement(TextExtended, { priority: "primary" }, t('empty-state.list-loading-text')))));
};
export default ListLoadingState;
//# sourceMappingURL=list-loading-state.js.map